export default function processPayLaterRule(
  raw: RawPayLaterRule,
): PayLaterRule {
  let maximumOrder: number | undefined;

  if (raw.MaximumOrder === 0) {
    maximumOrder = 0;
  } else if (raw.MaximumOrder) {
    maximumOrder = raw.MaximumOrder;
  } else {
    maximumOrder = undefined;
  }
  return {
    locationId: raw.Location == null ? undefined : String(raw.Location),
    state: raw.State || undefined,
    saleType: raw.SaleType || undefined,
    orderingProvider: raw.OrderingProvider || undefined,
    maximumOrder,
    memberOnly: Boolean(raw.MemberOnly),
  };
}
